module.exports = __webpack_public_path__ + "img/img6.0cb21cc7.png";